import { createQuery } from '@tanstack/svelte-query';
import { fetchScenes } from '$lib/api/scene';
import type { SceneResponse } from '$lib/types/scene';
import { resolveScope, getUnitScope, type ScopeFn } from './scope';

export const scenesQuery = (scope: ScopeFn = getUnitScope()) =>
	createQuery<Array<SceneResponse>>(() => {
		const unitId = resolveScope(scope);
		return {
			queryKey: ['scenes', { unitId }],
			queryFn: async () => {
				const all = await fetchScenes();
				return all.filter((s) => s.unit === unitId);
			},
			enabled: unitId > 0
		};
	});
